import { Box, Button, CircularProgress, Container, Grid, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import api from "../../../../../Apis";
import GoBack from "../../../../Globals/GoBack";
import { useTranslation } from "react-i18next";
import ProcessItem from "./Components/ProcessItem";
import ReplayIcon from '@mui/icons-material/Replay';
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";

export default function Process() {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromUrl = Number(searchParams.get("page")) || 1;
  const [cookies, setCookie] = useCookies('is_login');
  const [state, setState] = useState({
    datas: [],
    is_loading: true,
    total_page: 0,
    current_page: pageFromUrl,
    error_message: ""
  })
  

  const handlePageChange = (event, page) => {
    setSearchParams({ page });
  };

  useEffect(() => {
    setState(prev => ({
      ...prev,
      current_page: pageFromUrl,
      is_loading: true
    }));
  }, [pageFromUrl]);
  
  useEffect(() => {
    callApi();
  }, [state.current_page]);

  const reloadPage = () => {
    setState({...state, is_loading: true})
    callApi();
  }

  const callApi = () => {
    const requestOptions = {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + cookies.is_login
      }
    };
    fetch(api.process_list + `?lang=${i18n.language}&page=${state.current_page}`, requestOptions)
    .then(res => res.json())
    .then(
      (result) => {
          if (result.success) {
              setState({
                  ...state,
                  datas: result.data,
                  total_page: result.total_page,
                  is_loading: false,
                  error_message: ""
              })
          } else {
              setState({
                  ...state,
                  datas: [],
                  is_loading: false,
                  error_message: result.message
              })
          }
      } 
    )
  }

  const onDeleteProcess = (process_id) => {    
      Swal.fire({
        title: t("common.alert.confirmDelete"),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: t("common.alert.confirm"),
        cancelButtonText: t("common.alert.cancel"),
        confirmButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            }
          };
          fetch(`${api.delete_process}?process_id=${process_id}&lang=${i18n.language}`, requestOptions)
          .then(res => res.json())
          .then(result => {            
            if(result.success){
              const filteredDatas = state.datas.filter(item => item.id !== process_id);
              setState({
                ...state,
                datas: filteredDatas
              });
              Swal.fire(result?.message || t("common.message.deleteSuccess"), '', 'success');
            } else {
              Swal.fire(t("common.message.pleaseTryAgain"), '', 'error');
            }
          })
      }});
      
  }

  const onRePublishProcess = (process_id) => {
    // console.log("Re publish process id: ", process_id);
    
    Swal.fire({
      title: t("process.re_publish_comfirm_title"),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: t("common.alert.confirm"),
      cancelButtonText: t("common.alert.cancel"),
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const requestOptions = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + cookies.is_login
          },
          body: JSON.stringify({
            process_id: process_id,
            lang: i18n.language
          })
        };
        return fetch(api.re_publish_process, requestOptions)
        .then(res => res.json())
        .then(result => {
          if(result.success){
            Swal.fire(result?.message || t("process.re_publish_success"), '', 'success');
          } else {
            Swal.fire(result?.message || t("common.message.pleaseTryAgain"), '', 'error');
          }
        }).catch(() => {
          Swal.fire(t("common.message.pleaseTryAgain"), '', 'error');
        })
      }
    })
  }
  
  return (
    <Container maxWidth="xl">
      <div style={{ display: "flex", gap: "5px", justifyContent: "space-between", marginBottom: "15px" }}>
        {/* <GoBack/> */}
        <Typography variant="h6" gutterBottom>
          { t("post.processList")}
        </Typography>
        <Button onClick={reloadPage} startIcon={<ReplayIcon/>} className="text-transform" variant="contained" >Tải lại</Button>
      </div>
      <Grid item xs={12} md={12}>
        {state.total_page > 1 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Pagination
              count={state.total_page}
              page={state.current_page}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        )}
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>{t("process.no")}</TableCell>
                        <TableCell>{t("process.date")}</TableCell>
                        <TableCell>{t("process.name")}</TableCell>
                        <TableCell>{t("process.type")}</TableCell>
                        <TableCell>{t("process.total")}</TableCell>
                        <TableCell>{t("process.total_success")}</TableCell>
                        <TableCell>{t("process.total_error")}</TableCell>
                        <TableCell>{t("process.status")}</TableCell>
                        <TableCell>{t("process.action")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        state.is_loading
                        ?
                        <TableRow>
                            <TableCell colSpan={8} style={{ textAlign: "center" }}>
                                <CircularProgress />
                            </TableCell>
                        </TableRow>
                        :
                        state.datas.map((process_item, index) => {
                            return (
                                <ProcessItem
                                    key={index}
                                    stt = { index + 1 }
                                    process = { process_item }
                                    cookie={cookies.is_login}
                                    handleDeleteProcess={onDeleteProcess}
                                    handleRePublishProcess={onRePublishProcess} 
                                />
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
        {state.total_page > 1 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", paddingY: 3 }}>
            <Pagination
              count={state.total_page}
              page={state.current_page}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        )}
    </Grid>
  </Container>
  )
}